export default "__VITE_ASSET__d96ecc33__"